import DOMPurify from 'dompurify';

// Utility to decode HTML entities like &amp; to actual characters
function decodeEntities(html: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
}

/**
 * Converts richtext (HTML) to plain text lines:
 * - strips all tags
 * - decodes HTML entities
 * - splits by lines
 * - trims each line
 * - omits empty lines
 */
export function richTextToPlainTextLines(html: string): string[] {
    const stripped = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['a'],
        ALLOWED_ATTR: ['href'],
        KEEP_CONTENT: true,
        RETURN_TRUSTED_TYPE: false,
    });

    const decoded = decodeEntities(stripped);

    return decoded
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
}
